import { initializeApp, type FirebaseApp } from 'firebase/app';
import { connectAuthEmulator, getAuth, type Auth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore, type Firestore } from 'firebase/firestore';
import { connectStorageEmulator, getStorage, type FirebaseStorage } from 'firebase/storage';
import { connectFunctionsEmulator, getFunctions, type Functions } from 'firebase/functions';

// 환경변수가 비었을 때 에뮬레이터/SSR 프리렌더 단계에서도 빌드가 깨지지 않도록 빈 문자열 폴백
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? '',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'tilourday',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? '',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '',
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '',
};

let _app: FirebaseApp | null = null;
let _auth: Auth | null = null;
let _db: Firestore | null = null;
let _storage: FirebaseStorage | null = null;
let _functions: Functions | null = null;

function bootstrap(): FirebaseApp {
  if (_app) return _app;
  _app = initializeApp(firebaseConfig);

  if (import.meta.env.VITE_USE_EMULATORS === 'true' && typeof window !== 'undefined') {
    // 에뮬레이터 자동 연결 (개발 환경)
    _auth = getAuth(_app);
    _db = getFirestore(_app);
    _storage = getStorage(_app);
    _functions = getFunctions(_app, 'asia-northeast3');
    try {
      connectAuthEmulator(_auth, 'http://127.0.0.1:9099', { disableWarnings: true });
      connectFirestoreEmulator(_db, '127.0.0.1', 8080);
      connectStorageEmulator(_storage, '127.0.0.1', 9199);
      connectFunctionsEmulator(_functions, '127.0.0.1', 5001);
    } catch {
      // 핫리로드 시 중복 연결 시도 무시
    }
  }

  return _app;
}

export function firebaseApp() {
  return bootstrap();
}

export function auth() {
  if (!_auth) _auth = getAuth(bootstrap());
  return _auth;
}

export function db() {
  if (!_db) _db = getFirestore(bootstrap());
  return _db;
}

export function storage() {
  if (!_storage) _storage = getStorage(bootstrap());
  return _storage;
}

export function functions() {
  if (!_functions) _functions = getFunctions(bootstrap(), 'asia-northeast3');
  return _functions;
}
